export enum PolicyTypeEnum {
  ALWAYS_VIDEO = 'always_video',
  LOCKED_OFFICE = 'locked_office',
  RECORDING = 'recording',
  GUEST_INFORMATION = 'guest_information',
  MOTION_DETECTION = 'motion_detection',
  REPORTING = 'reporting',
}
